{
	"administrativeFee": "Umsýslugjald",
	"e1CustomsFee": "E1 tollskýrslugerð (yfir 40.000 kr.)",
	"tollkrit": "Umsýslugjald vegna tollkrítar (yfir 40.000 kr.)",
	"importFee": "Aðflutningsgjöld (VSK)",
	"administrativeFeeText": "Algengast er að viðskiptavinir greiði umsýslugjald 3. Við bendum ykkur á að kynna ykkur sjálfvirka greiðslu (umsýslugjald 2) hér til hliðar.",
	"vskText": "Algengast er að vörur beri 24% VSK en til að sjá nánari útlistun bendum við á vef",
	"shipmentFeeText": "Sendingargjald er aðeins rukkað af sendingum sem eru 2 kg eða léttari og passa í bréfalúgur.",
	"infoText": "Þetta eru áætluð gjöld miðað við þær upplýsingar sem slegnar voru inn og forsendur reiknivélarinnar.",
	"infoText2": "Sumar vörur bera toll og/eða úrvinnslugjöld. Nánari útlistun á vef",
	"infoText3": "Ef innflutt vara er leyfisskyld er gerð E1 tollskýrsla og bætist 360 kr fyrir hverja aukalínu sem þarf að gera á tollskýrsluna.",
	"link": "Tollstjóra.",
	"priceInIcelandicKronurs": "Verð í íslenskum krónum",
	"priceOfShipment": "Verð á vöru í ISK (vara + sendingarkostnaður)",
	"selectOptions": {
		"1": "Umsýslugjald 1. - 500 kr. Viðskiptavinur gerir tollskýrslu sjálfur",
		"2": "Umsýslugjald 2. - 660 kr. Viðskiptavinur er skráður í sjálfvirka greiðslu",
		"3": "Umsýslugjald 3. - 990 kr. Viðskiptavinur fær tilkynningu senda í tölvupósti",
		"4": "Umsýslugjald 4. - 1350 kr. Viðskiptavinur fær tilkynningu senda heim að dyrum í bréfi "
	},
	"sendingFee": "Sendingargjald",
	"sendingFeeEurope": "Sendingargjald Evrópu",
	"sendingFeeOutsideEurope": "Sendingargjald utan Evrópu",
	"total": "Samtals alls",
	"totalFee": "Gjöld samtals",
	"valueAddedTax": "Virðisaukaskattur - Innheimt af Tollstjóra",
	"valueAddedTaxShort": "VSK",
	"breakdown": "Sundurliðun"
}